// src/providers/LocalizationWrapper.tsx

import React, { useContext } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LanguageContext } from "../context/LanguageContext";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import localeData from "dayjs/plugin/localeData";

// Initialize dayjs plugins
dayjs.extend(updateLocale);
dayjs.extend(localeData);
dayjs.updateLocale("en", {
  weekStart: 1,
});
dayjs.updateLocale("nl", {
  weekStart: 1,
});

interface LocalizationWrapperProps {
  children: React.ReactNode;
}

export const LocalizationWrapper: React.FC<LocalizationWrapperProps> = ({ children }) => {
  const { currentLang } = useContext(LanguageContext);
  const adapterLocale = currentLang === "en" ? "en" : "nl";
  dayjs.locale(adapterLocale);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      {children}
    </LocalizationProvider>
  );
};
